import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCog, faSearch, faPlus } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Form, Button, ButtonGroup, InputGroup, Dropdown } from '@themesberg/react-bootstrap';
import Preloader from "../components/Preloader"; // Path to your code above
import { DriversTable } from "../../src/components/Tables";
import { use } from "react";
import { useState, useEffect } from "react";
import { getDriverDetails, getDriversList, setDriverSearch } from "../api/services/";
import TmsPopup from "../../src/components/Popup"; // Path to your code above
import AddressAddForm from "./forms/AddressAddForm"

export default () => {
  const [drivers, setDrivers] = useState({});
  const [search, setSearch] = useState("");
  const [pageSize, setPageSize] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);

  const [searchInput, setSearchInput] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showDriverAddWindow, setShowDriverAddWindow] = useState(false);
  // 🔹 Fetch drivers (TABLE)
  const fetchDrivers = async (page = 1, searchValue = search) => {
    try {
      console.log("API CALL → search:", searchValue);

      const data = await getDriversList({
        page,
        search: searchValue,
        page_size: pageSize,
      });

      setDrivers(data);
    } catch (error) {
      console.error(error);
    }
  };

  // 🔹 Debounce input
  useEffect(() => {
    const delay = setTimeout(() => {
      setSearch(searchInput);
    }, 400);

    return () => clearTimeout(delay);
  }, [searchInput]);

  // 🔹 Fetch when search changes
  useEffect(() => {
    setCurrentPage(1);
    fetchDrivers(1, search);
  }, [search]);

  // 🔹 Pagination
  useEffect(() => {
    fetchDrivers(currentPage, search);
  }, [currentPage, pageSize]);

  // 🔹 Suggestions
  useEffect(() => {
    const fetchSuggestions = async () => {
      if (!search || search.trim() === "") {
        setSuggestions([]);
        setShowDropdown(false);
        return;
      }

      try {
        const res = await getDriversList({
          page: 1,
          search,
          page_size: 5,
        });

        setSuggestions(res.drivers);
        setShowDropdown(true);
      } catch (error) {
        console.error(error);
      }
    };

    fetchSuggestions();
  }, [search]);

  // 🔹 Select suggestion
  const handleSelect = (driver) => {
    const value = `${driver.first_name} ${driver.last_name}`;
    setSearchInput(value);
    setSearch(value);
    setShowDropdown(false);
  };

  // 🔹 Pagination click
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleDriverClick = async (e) => {
    // setShowLoader(true);
    e.preventDefault();
    setShowDriverAddWindow(true);
  };
  return (
    <>
      {/* <Preloader show={showLoader} /> */}
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <h4>My Routes</h4>
          <p className="mb-0">This is your routes dashboard.</p>
        </div>
        <div className="btn-toolbar mb-2 mb-md-0">
          <ButtonGroup>
            <Button variant="outline-primary" size="sm">Upload</Button>
            <Button variant="outline-primary" size="sm">Sample</Button>
          </ButtonGroup>
        </div>
      </div>

      <div className="table-settings mb-4">
        <Row className="justify-content-between align-items-center">
          <Col xs={8} md={6} lg={3} xl={4}>
            <InputGroup>
              <InputGroup.Text>
                <FontAwesomeIcon icon={faSearch} />
              </InputGroup.Text>
              <Form.Control
                type="text" placeholder="Search Routes.."
                // type="text"
                className="form-control"
                // placeholder="Search driver..."
                value={searchInput}
                onChange={(e) => {
                  console.log("Typing:", e.target.value);
                  setSearchInput(e.target.value);
                }}
                onFocus={() => setShowDropdown(true)}
              />
            </InputGroup>
          </Col>
          <Col xs={8} md={6} xl={5} className="ps-md-0 text-end">
            <Button variant="secondary" className="text-dark me-3" onClick={handleDriverClick}>
              <FontAwesomeIcon icon={faPlus} className="d-none d-sm-inline ms-1" />  Add New Address </Button>
            <Button variant="secondary" className="text-dark me-3" onClick={handleDriverClick}>
              <FontAwesomeIcon icon={faPlus} className="d-none d-sm-inline ms-1" />  Add New Route </Button>
          </Col>
        </Row>
      </div>

      <TmsPopup show={showDriverAddWindow}
        handleClose={() => setShowDriverAddWindow(false)}
        title="Add Address"
        onSave={() => {
          console.log("Save clicked");
          setShowDriverAddWindow(false);
        }}>
        <AddressAddForm />
      </TmsPopup>
      <DriversTable
        driversResponse={drivers}
        onPageChange={handlePageChange}
        currentPage={currentPage}
      />
    </>
  );
};
